import { render } from "./ItemCategory.vue?vue&type=template&id=d5b3a628"
import script from "./ItemCategory.vue?vue&type=script&lang=js"
export * from "./ItemCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__